import React from 'react'
import './ReaperContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'

export class ReaperContent extends React.Component {
  render() {
    return (
      <div className="reaper-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            REAPER is Rackner's AI-enabled microservices platform that accelerates
            the OODA loop for command and control operators - processing vast data
            streams, identifying actionable entities, and generating prioritized
            battle recommendations while keeping humans in control.
          </div>
        </div>

        <section className="padding-large">
          <div className="row">
            <div className="col-md-12">
              <h2>The Challenge</h2>
              <p>
                Modern multi-domain operations create overwhelming cognitive load for
                battle managers and C2 operators. They must process massive amounts of
                real-time data from tactical data links, ISR sensors, communications
                networks, and geospatial sources while making time-critical decisions
                that can determine mission success or failure.
              </p>
            </div>
          </div>
        </section>

        <div className="split pattern">
          <h2>How REAPER Works</h2>
          <div className="row capabilities-grid">
            <div className="col-md-6">
              <div className="capability-card">
                <div className="title">Autonomous Data Processing</div>
                <div className="description">
                  Ingests and fuses data from Link-16, JREAP-C, ISR feeds, voice
                  transcription, and radar tracks in real-time using modular
                  microservices architecture.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="capability-card">
                <div className="title">AI/ML-Powered Analysis</div>
                <div className="description">
                  Delivers prioritized courses of action in a fraction of the time,
                  accelerating the OODA loop while maintaining human decision authority. 
                  Air Force battle managers rated REAPER highly during operational testing.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="capability-card">
                <div className="title">Explainable AI</div>
                <div className="description">
                  Maintains transparency through LIME and SHAP frameworks so
                  operators understand and validate recommendations before
                  taking action.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="capability-card">
                <div className="title">Human-Machine Teaming</div>
                <div className="description">
                  Augments operator capabilities without replacing human judgment,
                  keeping humans in control of all decision-making authority.
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="padding-large light">
          <div className="row">
            <div className="col-md-12">
              <h2>Proven Results</h2>
              <div className="results-section">
                <div className="result-item">
                  <div className="metric">TRL 7</div>
                  <div className="description">
                    Achieved during operational demonstrations at the U.S. Air Force's
                    Shadow Operations Center
                  </div>
                </div>
                <div className="result-item">
                  <div className="metric">561</div>
                  <div className="description">
                    Autonomous battle Courses of Action generated during demonstration
                  </div>
                </div>
                <div className="result-item">
                  <div className="metric">2x Faster</div>
                  <div className="description">
                    Improvement in operator decision speed compared to manual processes
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="split">
          <h2>Integration Pathways</h2>
          <div className="text-wrap centered">
            <p>
              REAPER is positioned for integration with Navy and NAVAIR systems
              including Project Overmatch, AEGIS combat systems, Naval Integrated
              Fire Control-Counter Air (NIFC-CA), and the Common Control System
              for unmanned platforms. The modular architecture enables rapid
              adaptation to service-specific use cases from carrier strike group
              air defense to distributed maritime operations.
            </p>
          </div>
        </div>

        <div className="split light">
          <h2>Fast Acquisition Pathways</h2>
          <div className="text-wrap centered">
            <p>
              REAPER is available for direct award through three streamlined
              government marketplaces, enabling acquisition in as few as 30 days.
            </p>
          </div>
          <div className="marketplace-logos">
            <img src="/p1-marketplace.png" alt="Platform One Marketplace" />
            <img src="/tradewinds-marketplace-1.png" alt="Tradewinds Marketplace" />
            <img src="/darpa-eris.png" alt="DARPA ERIS" />
          </div>
          <div className="button-wrap">
            <Link to="/contact">
              <button className="btn-raised-light-blue-inverse big">
                Learn More
              </button>
            </Link>
          </div>
        </div>

        <CallToActionBanner route={'insights'} linkText={'See Case Studies'} />
      </div>
    )
  }
}

export default ReaperContent
